import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles(theme => ({
    recoveryFormContainer: {
       height: '100%',
       display: 'flex',
       flexDirection: 'column',
       justifyContent: 'center',
       margin: theme.spacing(0, 2)
    },
    title: {
       fontFamily: 'Roboto',
       fontStyle: 'normal',
       fontSize: 16,
       letterSpacing: '-0.06px'
    },
    subtitle: {
       fontFamily: 'Roboto',
       fontStyle: 'normal',
       fontWeight: 'normal',
       fontSize: 14,
       letterSpacing: '-0.05px',
       color: '#9EA0A5'
    },
    submit: {
       margin: theme.spacing(1, 0, 2, 0),
       textTransform: 'none',
       width: '100%'
    },
    formCleanButton: {
       color: '#3264DC',
       border: '1px solid #3264DC',
       fontWeight: 'bold',
       marginTop: 20,
       width: '100%'
    },
    recaptchaContainer: {
       margin: theme.spacing(2, 0, 1, 0)
    },
    recaptchaHelperText: {
       color: '#f44336',
       margin: '4px 14px 0'
    },
    backButtonContainer: {
       marginTop: theme.spacing(1)
    }
 }))